import React from 'react';
import { cssSafeName } from '../../util/css';
import RequiredAsterisk from '../RequiredAsterisk';

export default function VgsInputLabel({
  label,
  required,
  className,
}: {
  required: boolean;
  label: string;
  className?: string;
}): JSX.Element {
  return (
    <label
      style={{
        marginBottom: '6px',
      }}
      htmlFor={cssSafeName(label)}
      className={className || 'text-sm text-[#1e293b] leading-5 font-medium'}
    >
      {label || <span>&nbsp;</span>}
      {required && <RequiredAsterisk />}
    </label>
  );
}
